import request from './services/axios.js'

export const submitForm = (params) => {
  return request({
    data: params,
    url: 'ebook/questionnaire/submit',
    method: 'POST'
  })
}

export const getFormList = (params) => {
  return request({
    params,
    url: 'ebook/questionnaire/getFormByPage',
    method: 'get'
  })
}

export const getFormData = (params) => {
  return request({
    params,
    url: 'ebook/questionnaire/getFormDataByPage',
    method: 'get'
  })
}

export const deleteData = (params) => {
  return request({
    params,
    url: 'ebook/questionnaire/deleteData',
    method: 'POST'
  })
}
